module.exports = __webpack_public_path__ + "img/476.0ba4c00c.png";